import { forwardRef } from 'react'
import { AghanimIcon, IconBase } from '../IconBase'

export const ChevronLeftRounded: AghanimIcon = forwardRef(function (props, ref) {
  return (
    <IconBase {...props} viewBox="0 0 14 14" ref={ref}>
      <path
        d="M6 1C9.03757 1 11.5 3.46243 11.5 6.5C11.5 9.53757 9.03757 12 6 12C2.96243 12 0.5 9.53757 0.5 6.5C0.5 3.46243 2.96243 1 6 1ZM7.10352 4.14648C6.90825 3.95122 6.59175 3.95122 6.39648 4.14648L4.39648 6.14648C4.20122 6.34175 4.20122 6.65825 4.39648 6.85352L6.39648 8.85352C6.59175 9.04878 6.90825 9.04878 7.10352 8.85352C7.29878 8.65825 7.29878 8.34175 7.10352 8.14648L5.45703 6.5L7.10352 4.85352C7.29878 4.65825 7.29878 4.34175 7.10352 4.14648Z"
        fill="currentColor"
      />
    </IconBase>
  )
})
